// Gender-tinted initials avatar shown until a user uploads their own picture.
// Pink for Male, cream for Female / Non-Binary / unset — deliberately plain so
// users are nudged to personalise their profile.
export function initialsOf(name) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  return parts.map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}

function bgFor(gender) {
  if (gender === "Male") return "#F7B7CB"; // pink
  return "#F3ECDC"; // cream (Female / Non-Binary / Prefer Not to Say / unset)
}

export default function DefaultAvatar({ name, gender, className = "" }) {
  const bg = bgFor(gender);
  const ini = initialsOf(name);
  return (
    <svg
      viewBox="0 0 100 100"
      className={`w-full h-full ${className}`}
      preserveAspectRatio="xMidYMid slice"
      data-testid="default-avatar"
      role="img"
      aria-label={`${name || "User"} default avatar`}
    >
      <rect width="100" height="100" fill={bg} />
      <text x="50" y="46" textAnchor="middle" dominantBaseline="central"
        fontFamily="Georgia, 'Times New Roman', serif" fontWeight="800" fontSize="40" fill="#111111">
        {ini}
      </text>
      <text x="50" y="82" textAnchor="middle"
        fontFamily="'Courier New', monospace" fontSize="9" letterSpacing="2" fill="#111111" opacity="0.7">
        misteck
      </text>
    </svg>
  );
}
